import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Locale-aware navigation primitives. Use these EVERYWHERE instead of
 * Next.js's built-in `Link`, `useRouter`, `usePathname`, `redirect`.
 *
 * The wrappers handle:
 *   - Auto-prepending the current locale to internal URLs
 *   - `pathname` returns the locale-stripped path (so the LanguageSwitcher
 *     can `router.replace(pathname, { locale: 'en' })` and stay on same page)
 *   - Cookie write on active locale switch
 *
 * Spec: ~/.claude/specs/2026-05-15-i18n-overhaul-design.md §2.4
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
